import React from 'react';
import { motion } from 'framer-motion';
export function HeroVisual() {
  return <div className="relative w-full h-[400px] md:h-[500px] flex items-center justify-center" data-id="element-82">
      {/* Glowing Core */}
      <motion.div animate={{
      scale: [1, 1.2, 1],
      opacity: [0.5, 0.8, 0.5]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute w-64 h-64 bg-neon-cyan/20 rounded-full blur-[80px]" data-id="element-83" />
      <motion.div animate={{
      scale: [1.2, 1, 1.2],
      opacity: [0.3, 0.6, 0.3]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute w-64 h-64 bg-electric-violet/20 rounded-full blur-[80px] translate-x-10" data-id="element-84" />

      {/* Connected Nodes */}
      <svg className="w-full h-full" viewBox="0 0 400 400" data-id="element-85">
        <defs data-id="element-86">
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-87">
            <stop offset="0%" stopColor="#00D9FF" stopOpacity="0.2" data-id="element-88" />
            <stop offset="100%" stopColor="#8B5CF6" stopOpacity="0.2" data-id="element-89" />
          </linearGradient>
        </defs>

        {/* Animated Lines */}
        {[...Array(8)].map((_, i) => <motion.line key={i} x1={200} y1={200} x2={200 + Math.cos(i * 0.8) * 150} y2={200 + Math.sin(i * 0.8) * 150} stroke="url(#lineGradient)" strokeWidth="1" initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: 1,
        opacity: 1
      }} transition={{
        duration: 2,
        delay: i * 0.1,
        ease: 'easeOut'
      }} data-id="element-90" />)}

        {/* Floating Nodes */}
        {[...Array(8)].map((_, i) => <motion.circle key={`node-${i}`} cx={200 + Math.cos(i * 0.8) * 150} cy={200 + Math.sin(i * 0.8) * 150} r="4" fill="#fff" initial={{
        scale: 0
      }} animate={{
        scale: [1, 1.5, 1]
      }} transition={{
        duration: 3,
        delay: i * 0.2,
        repeat: Infinity
      }} data-id="element-91" />)}

        {/* Central Hub */}
        <circle cx="200" cy="200" r="20" fill="url(#lineGradient)" className="blur-sm" data-id="element-92" />
        <circle cx="200" cy="200" r="10" fill="#fff" data-id="element-93" />
      </svg>
    </div>;
}
export function VisionVisual() {
  return <div className="relative w-full h-[300px] flex items-center justify-center" data-id="element-94">
      {/* Merging Concepts */}
      <motion.div className="absolute border border-neon-cyan/30 rounded-full w-32 h-32 flex items-center justify-center backdrop-blur-sm" animate={{
      x: [0, 20, 0],
      y: [0, -20, 0]
    }} transition={{
      duration: 6,
      repeat: Infinity
    }} data-id="element-95">
        <div className="w-2 h-2 bg-neon-cyan rounded-full shadow-[0_0_10px_#00D9FF]" data-id="element-96" />
      </motion.div>

      <motion.div className="absolute border border-electric-violet/30 rounded-full w-40 h-40 flex items-center justify-center backdrop-blur-sm" animate={{
      x: [0, -20, 0],
      y: [0, 20, 0]
    }} transition={{
      duration: 7,
      repeat: Infinity
    }} data-id="element-97">
        <div className="w-2 h-2 bg-electric-violet rounded-full shadow-[0_0_10px_#8B5CF6]" data-id="element-98" />
      </motion.div>

      <motion.div className="absolute border border-white/20 rounded-full w-24 h-24 flex items-center justify-center backdrop-blur-sm" animate={{
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 4,
      repeat: Infinity
    }} data-id="element-99">
        <div className="w-2 h-2 bg-white rounded-full shadow-[0_0_10px_white]" data-id="element-100" />
      </motion.div>
    </div>;
}
export function TeamVisual() {
  return <div className="relative w-full h-[300px] flex items-center justify-center overflow-hidden" data-id="element-101">
      <div className="absolute inset-0 bg-gradient-to-t from-deep-dark to-transparent z-10" data-id="element-102" />

      <svg className="w-full h-full opacity-50" viewBox="0 0 800 300" data-id="element-103">
        {[...Array(20)].map((_, i) => <motion.path key={i} d={`M ${i * 40} 300 Q ${i * 40 + 20} ${150 + Math.sin(i) * 50} ${i * 40 + 40} 300`} stroke="rgba(255,255,255,0.1)" fill="none" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} transition={{
        duration: 2,
        delay: i * 0.05
      }} data-id="element-104" />)}

        {/* Connecting dots representing people */}
        {[...Array(15)].map((_, i) => <motion.circle key={i} cx={100 + i * 40 + Math.random() * 20} cy={100 + Math.random() * 100} r="2" fill={i % 2 === 0 ? '#00D9FF' : '#8B5CF6'} animate={{
        y: [0, -10, 0],
        opacity: [0.3, 1, 0.3]
      }} transition={{
        duration: 3 + Math.random() * 2,
        repeat: Infinity,
        delay: Math.random() * 2
      }} data-id="element-105" />)}
      </svg>
    </div>;
}